/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 9/1/15.
 */
'use strict';
angular.module('prism-ui.components.filters').filter('durationFromSec', function () {

	var padString = function(value, precision, round) {
		var string = '' + Math.floor(value);

		while(string.length < precision) {
			string = '0' + string;
		}
		return string;
	};

	return function (input) {
		if (input) {
			var seconds = input;
			var hours = (seconds / 3600) % 3600;
			var minutes = (seconds / 60) % 60;
			seconds %= 60;

			var label = padString(hours, 2);
			label += ':' + padString(minutes, 2);
			label += ':' + padString(seconds, 2);
			return label;
		}
		return '';
	};
});
